export default __webpack_public_path__ + "static/media/TL13.2.756562c1.mp3";